/**
 * This file contains all release dates for features across the application.
 * All release dates should be defined here and imported where needed.
 */

// Dashboard release dates
export const NEW_DASHBOARD_RELEASE_DATE = new Date('2023-11-01');

// Waitlist has moved release date
export const WAITLIST_MOVED_RELEASE_DATE = new Date('2025-09-18');

// Discount codes release dates
export const DISCOUNT_CODE_FEATURE_RELEASE_DATE = new Date('2025-09-02');
export const SCHEDULE_FEATURE_RELEASE_DATE = new Date('2025-06-18');
export const DISCOUNT_CODE_CUSTOM_TIMESLOT_ON_IMPORT_DATE = new Date('2025-09-25');

// Event information release dates
export const BULK_TIMESLOT_EDIT_RELEASE_DATE = new Date('2024-09-23');
export const CONFIRMATION_EMAIL_RELEASE_DATE = new Date('2024-12-23');

// Add attractions release date
export const ADD_ATTRACTIONS_RELEASE_DATE = new Date('2024-03-12');

// Fan reminder waitlist release date
export const NEW_FAN_REMINDER_RELEASE_DATE = new Date('2025-08-08');
